const JSON_HEADERS = {
  "Content-Type": "application/json",
};

async function corporateSignupRequest(url, options = {}) {
  const response = await fetch(url, {
    credentials: "include",
    headers: {
      ...JSON_HEADERS,
      ...(options.headers || {}),
    },
    ...options,
  });

  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    data = null;
  }

  if (!response.ok) {
    const error = new Error(
      data?.error || data?.message || `Request failed with status ${response.status}`
    );
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

export function corporateSignupStart(payload) {
  return corporateSignupRequest("/api/corporate-signup/start", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function corporateSignupVerify(payload) {
  return corporateSignupRequest("/api/corporate-signup/verify", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function corporateSignupCheckSchoolId(schoolName, options = {}) {
  const params = new URLSearchParams({ school_name: schoolName });
  return corporateSignupRequest(`/api/corporate-signup/check-school-id?${params}`, {
    method: "GET",
    signal: options.signal,
  });
}
